export default "__VITE_ASSET__22e1fb14__"